export const getPaymentTermsModalHtml = () => `<div id="terms" style="display: none;">
<div id="terms-modal">
    <a href="./#" id="terms-modal-close">&times;</a>
    <textarea id="terms-modal-content" readonly>{paidnewsletterterms}</textarea>
</div>
</div>
</body>`; // it replaces '</body>' in html

export const paymentTermsModalStyles = `
<style>
#terms {
    display: none;
    box-sizing:border-box;
    position:fixed;
    inset:0;
    z-index: 1;
    padding:5px;
    background:rgba(0,0,0,0.2);
}
#terms:target {
    display: block !important;
}
#terms-modal {
    box-sizing:border-box;
    position:absolute;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
    width: 1000px;
    max-width:100%;
    max-height:100%;
    padding:50px 20px 30px;
    background:#fff;
    border-radius:5px;
}
#terms-modal-close {
    color:#aaa;
    font-size: 40px;
    font-weight: bold;
    cursor: pointer;
    position: absolute;
    top:0;
    right:15px;
    text-decoration: none;
}
#terms-modal-content {
    box-sizing:border-box;
    padding:10px;
    font-size:16px;
    font-family: Arial, sans-serif;
    width:100%;
    resize: none;
    max-height:80vh;
    min-height:50vh;
    border:0;
}
@media (max-width: 767px) {
    #terms-modal-content {
        min-height: 200px;
        max-height: initial;
        height: calc(100vh - 90px);
    }
}
</style>
`;
